import Building02 from '@/assets/icons/Building02.vue'
import BellRinging04 from '@/assets/icons/BellRinging04.vue'
import CoinsHand from '@/assets/icons/CoinsHand.vue'
import CreditCard01 from '@/assets/icons/CreditCard01.vue'
import BookClosed from '@/assets/icons/BookClosed.vue'
import QrCode02 from '@/assets/icons/QrCode02.vue'
import Receipt from '@/assets/icons/Receipt.vue'
import ReceiptCheck from '@/assets/icons/ReceiptCheck.vue'
import Edit02 from '@/assets/icons/Edit02.vue'
import FilterLine from '@/assets/icons/FilterLine.vue'
import Settings02 from '@/assets/icons/Settings02.vue'
import Announcement03 from '@/assets/icons/Announcement03.vue'
import User02 from '@/assets/icons/User02.vue'
import User03 from '@/assets/icons/User03.vue'
import UserCheck01 from '@/assets/icons/UserCheck01.vue'
import Users02 from '@/assets/icons/Users02.vue'
import UserCircle from '@/assets/icons/UserCircle.vue'
import UserEdit from '@/assets/icons/UserEdit.vue'
import Upload01 from '@/assets/icons/Upload01.vue'
import Upload03 from '@/assets/icons/Upload03.vue'
import Download01 from '@/assets/icons/Download01.vue'
import Trash04 from '@/assets/icons/Trash04.vue'
import Trash03 from '@/assets/icons/Trash03.vue'
import Calendar from '@/assets/icons/Calendar.vue'
import Hourglass03 from '@/assets/icons/Hourglass03.vue'
import UserPlus01 from '@/assets/icons/UserPlus01.vue'
import Mail01 from '@/assets/icons/Mail01.vue'
import MessageCircle01 from '@/assets/icons/MessageCircle01.vue'
import ChevronDown from '@/assets/icons/ChevronDown.vue'
import AlertCircleSolid from '@/assets/icons/AlertCircleSolid.vue'
import CheckCircle from '@/assets/icons/CheckCircle.vue'
import CheckCircleSolid from '@/assets/icons/CheckCircleSolid.vue'
import GoogleIcon from '@/assets/icons/GoogleIcon.vue'
import Plus from '@/assets/icons/Plus.vue'
import Copy03 from '@/assets/icons/Copy03.vue'
import MedicalCross from '@/assets/icons/MedicalCross.vue'
import DotsGrid02 from '@/assets/icons/DotsGrid02.vue'
import Lock03 from '@/assets/icons/Lock03.vue'
import SearchSm from '@/assets/icons/SearchSm.vue'
import FilterFunnel01 from '@/assets/icons/FilterFunnel01.vue'
import ChevronUp from '@/assets/icons/ChevronUp.vue'
import Automatic from '@/assets/icons/Automatic.vue'
import List from '@/assets/icons/List.vue'
import Triangle from '@/assets/icons/Triangle.vue'
import DataFlow01 from '@/assets/icons/DataFlow01.vue'
import Star04 from '@/assets/icons/Star04.vue'
import Bell01 from '@/assets/icons/Bell01.vue'
import User01 from '@/assets/icons/User01.vue'
import YezzaIcon from '@/assets/icons/YezzaIcon.vue'
import ThumbsUp from '@/assets/icons/ThumbsUp.vue'
import Star01 from '@/assets/icons/Star01.vue'
import Star01Fill from '@/assets/icons/Star01Fill.vue'
import IosBatteryFull from '@/assets/icons/IosBatteryFull.vue'
import IosSafariSafeLock from '@/assets/icons/IosSafariSafeLock.vue'
import IosSafariReplyArrow from '@/assets/icons/IosSafariReplyArrow.vue'
import GmailIcon from '@/assets/icons/GmailIcon.vue'
import CheckVerified02 from '@/assets/icons/CheckVerified02.vue'
import MessageSquare02 from '@/assets/icons/MessageSquare02.vue'
import ChevronDownDouble from '@/assets/icons/ChevronDownDouble.vue'
import ChevronUpDouble from '@/assets/icons/ChevronUpDouble.vue'
import Edit05 from '@/assets/icons/Edit05.vue'
import Printer from '@/assets/icons/Printer.vue'
import LayoutLeft from '@/assets/icons/LayoutLeft.vue'
import File04 from '@/assets/icons/File04.vue'
import ArrowNarrowUpRight from '@/assets/icons/ArrowNarrowUpRight.vue'
import Folder from '@/assets/icons/Folder.vue'
import Colors from '@/assets/icons/Colors.vue'
import Scan from '@/assets/icons/Scan.vue'
import Phone from '@/assets/icons/Phone.vue'
import CornerDownRight from '@/assets/icons/CornerDownRight.vue'
import PlusCircle from '@/assets/icons/PlusCircle.vue'
import XCircle from '@/assets/icons/XCircle.vue'
import Menu03 from '@/assets/icons/Menu03.vue'
import Menu05 from '@/assets/icons/Menu05.vue'
import Phone02 from '@/assets/icons/Phone02.vue'
import Dotpoints02 from '@/assets/icons/Dotpoints02.vue'
import Markerpin02 from '@/assets/icons/Markerpin02.vue'
import Mail02 from '@/assets/icons/Mail02.vue'
import Number123 from '@/assets/icons/123.vue'
import AlarmClock from '@/assets/icons/AlarmClock.vue'
import ArrowUp from '@/assets/icons/ArrowUp.vue'
import ArrowDown from '@/assets/icons/ArrowDown.vue'
import Key02 from '@/assets/icons/Key02.vue'
import Copy02 from '@/assets/icons/Copy02.vue'
import ArrowNarrowLeft from '@/assets/icons/ArrowNarrowLeft.vue'
import Circle from '@/assets/icons/Circle.vue'
import Clock from '@/assets/icons/Clock.vue'
import Image01 from '@/assets/icons/Image01.vue'
import Download02 from '@/assets/icons/Download02.vue'
import PackagePlus from '@/assets/icons/PackagePlus.vue'
import Tag02 from '@/assets/icons/Tag02.vue'
import File06 from '@/assets/icons/File06.vue'
import AlertCircle from '@/assets/icons/AlertCircle.vue'
import ImageUserX from '@/assets/icons/ImageUserX.vue'
import Box from '@/assets/icons/Box.vue'
import Ticket01 from '@/assets/icons/Ticket01.vue'
import Cube01 from '@/assets/icons/Cube01.vue'
import Monitor05 from '@/assets/icons/Monitor05.vue'
import FileHeart02 from '@/assets/icons/FileHeart02.vue'
import HomeSmile from '@/assets/icons/HomeSmile.vue'
import LockKeyholeCircle from '@/assets/icons/LockKeyholeCircle.vue'
import Palette from '@/assets/icons/Palette.vue'
import SlashCircle01 from '@/assets/icons/SlashCircle01.vue'
import LogOut01 from '@/assets/icons/LogOut01.vue'
import Stars02 from '@/assets/icons/Stars02.vue'
import MedicalSquare from '@/assets/icons/MedicalSquare.vue'
import Edit03 from '@/assets/icons/Edit03.vue'
import Eye from '@/assets/icons/Eye.vue'
import LayoutLeftFilled from '@/assets/icons/LayoutLeftFilled.vue'
import CalendarFilter from '@/assets/icons/CalendarFilter.vue'
import BarChart10 from '@/assets/icons/BarChart10.vue'
import PencilLine from '@/assets/icons/PencilLine.vue'
import FileAttachment01 from '@/assets/icons/FileAttachment01.vue'
import File07 from '@/assets/icons/File07.vue'
import FileSearch02 from '@/assets/icons/FileSearch02.vue'
import DotsHorizontal from '@/assets/icons/DotsHorizontal.vue'
import Columns03 from '@/assets/icons/Columns03.vue'
import LayoutTop from '@/assets/icons/LayoutTop.vue'
import Grid01 from '@/assets/icons/Grid01.vue'
import CalendarTick from '@/assets/icons/CalendarTick.vue'
import Repeat01 from '@/assets/icons/Repeat01.vue'
import Repeat03 from '@/assets/icons/Repeat03.vue'
import Check from '@/assets/icons/Check.vue'
import PlayCircle from '@/assets/icons/PlayCircle.vue'
import PauseCircle from '@/assets/icons/PauseCircle.vue'
import InfoSquare from '@/assets/icons/InfoSquare.vue'
import ActivityHeart from '@/assets/icons/ActivityHeart.vue'
import Users03 from '@/assets/icons/Users03.vue'
import Save01 from '@/assets/icons/Save01.vue'
import Hourglass02 from '@/assets/icons/Hourglass02.vue'
import InfoCircle from '@/assets/icons/InfoCircle.vue'
import File05 from '@/assets/icons/File05.vue'
import ArrowUpRight from '@/assets/icons/ArrowUpRight.vue'
import UsersSolid03 from '@/assets/icons/UsersSolid03.vue'
import CalendarSolid from '@/assets/icons/CalendarSolid.vue'
import ClockCheckSolid from '@/assets/icons/ClockCheckSolid.vue'
import PackageCheckSolid from '@/assets/icons/PackageCheckSolid.vue'
import CalendarCheckSolid01 from '@/assets/icons/CalendarCheckSolid01.vue'
import MarkerPinSolid04 from '@/assets/icons/MarkerPinSolid04.vue'
import Archive from '@/assets/icons/Archive.vue'
import Link03 from '@/assets/icons/Link03.vue'
import TextInput from '@/assets/icons/TextInput.vue'
import UsersPlus from '@/assets/icons/UsersPlus.vue'
import WalletSolid02 from '@/assets/icons/WalletSolid02.vue'
import AlertSquare from '@/assets/icons/AlertSquare.vue'
import UserPlusSolid01 from '@/assets/icons/UserPlusSolid01.vue'
import CoinsHandSolid from '@/assets/icons/CoinsHandSolid.vue'
import GiftSolid01 from '@/assets/icons/GiftSolid01.vue'
import AlertTriangle from '@/assets/icons/AlertTriangle.vue'
import CheckVerifiedSolid03 from '@/assets/icons/CheckVerifiedSolid03.vue'
import Gift02 from '@/assets/icons/Gift02.vue'
import Phone02New from '@/assets/icons/Phone02New.vue'
import MessageDotsSquare from '@/assets/icons/MessageDotsSquare.vue'
import Link01 from '@/assets/icons/Link01.vue'
import PresentationChart01 from '@/assets/icons/PresentationChart01.vue'
import RefreshCw02 from '@/assets/icons/RefreshCw02.vue'
import Share03 from '@/assets/icons/Share03.vue'
import Home03 from '@/assets/icons/Home03.vue'
import Delete from '@/assets/icons/Delete.vue'
import Award02 from '@/assets/icons/Award02.vue'
import MessageTextSquare02 from '@/assets/icons/MessageTextSquare02.vue'
import Zap from '@/assets/icons/Zap.vue'
import Offers from '@/assets/icons/Offers.vue'
import Attachment01 from '@/assets/icons/Attachment01.vue'
import Maximize01 from '@/assets/icons/Maximize01.vue'
import File02 from '@/assets/icons/File02.vue'
import Clipboard from '@/assets/icons/Clipboard.vue'
import ClipboardCheck from '@/assets/icons/ClipboardCheck.vue'
import Package from '@/assets/icons/Package.vue'
import Stethoscope from '@/assets/icons/Stethoscope.vue'
import Medicine from '@/assets/icons/Medicine.vue'
import Calculator from '@/assets/icons/Calculator.vue'
import CheckSquareSolid from '@/assets/icons/CheckSquareSolid.vue'
import CheckboxUncheck from '@/assets/icons/CheckboxUncheck.vue'
import CheckSquare from '@/assets/icons/CheckSquare.vue'
import LayoutAltDuotone04 from '@/assets/icons/LayoutAltDuotone04.vue'
import Rows01 from '@/assets/icons/Rows01.vue'
import BarChartSquareLine01 from '@/assets/icons/BarChartSquareLine01.vue'
import MenuDuocolor01 from '@/assets/icons/MenuDuocolor01.vue'
import BarChartSolid04 from '@/assets/icons/BarChartSolid04.vue'
import ShoppingCartLine03 from '@/assets/icons/ShoppingCartLine03.vue'
import CalculatorLine from '@/assets/icons/CalculatorLine.vue'
import TruckLine02 from '@/assets/icons/TruckLine02.vue'
import BellRingingLine02 from '@/assets/icons/BellRingingLine02.vue'
import CalendarCheckLine01 from '@/assets/icons/CalendarCheckLine01.vue'
import BarChartSquareSolid01 from '@/assets/icons/BarChartSquareSolid01.vue'
import PackageSolid from '@/assets/icons/PackageSolid.vue'
import BellSolid01 from '@/assets/icons/BellSolid01.vue'
import Dispense from '@/assets/icons/Dispense.vue'
import CursorClickLine01 from "@/assets/icons/CursorClickLine01.vue"
import LineSend01 from "@/assets/icons/LineSend01.vue"
import LinkExternalSolid01 from "@/assets/icons/LinkExternalSolid01.vue"
import QrCode01 from "@/assets/icons/QrCode01.vue"
import FileQuestion02 from "@/assets/icons/FileQuestion02.vue"
import SwitchHorizontalDuotone01 from "@/assets/icons/SwitchHorizontalDuotone01.vue"
import Edit01 from '@/assets/icons/Edit01.vue'
import Repeat04 from '@/assets/icons/Repeat04.vue'
import XSm from '@/assets/icons/XSm.vue'
import ReverseLeft from '@/assets/icons/ReverseLeft.vue'
import MarkerPin01 from '@/assets/icons/MarkerPin01.vue'
import Building01 from '@/assets/icons/Building01.vue'
import Settings01 from '@/assets/icons/Settings01.vue'
import LinkBroken02 from '@/assets/icons/LinkBroken02.vue'
import CalendarPlus02 from "@/assets/icons/CalendarPlus02.vue"

export const yzicons = {
  'yzi-building-02': { component: Building02 },
  'yzi-bell-ringing-04': { component: BellRinging04 },
  'yzi-coins-hand': { component: CoinsHand },
  'yzi-credit-card-01': { component: CreditCard01 },
  'yzi-receipt': { component: Receipt },
  'yzi-receipt-check': { component: ReceiptCheck },
  'yzi-qr-code-02': { component: QrCode02 },
  'yzi-book-closed': { component: BookClosed },
  'yzi-edit-02': { component: Edit02 },
  'yzi-filter-line': { component: FilterLine },
  'yzi-settings-02': { component: Settings02 },
  'yzi-user-02': { component: User02 },
  'yzi-user-03': { component: User03 },
  'yzi-user-check-01': { component: UserCheck01 },
  'yzi-users-02': { component: Users02 },
  'yzi-user-circle': { component: UserCircle },
  'yzi-user-edit': { component: UserEdit },
  'yzi-upload-01': { component: Upload01 },
  'yzi-upload-03': { component: Upload03 },
  'yzi-download-01': { component: Download01 },
  'yzi-trash-04': { component: Trash04 },
  'yzi-trash-03': { component: Trash03 },
  'yzi-calendar': { component: Calendar },
  'yzi-announcement-03': { component: Announcement03 },
  'yzi-hourglass-03': { component: Hourglass03 },
  'yzi-user-plus-01': { component: UserPlus01 },
  'yzi-mail-01': { component: Mail01 },
  'yzi-message-circle-01': { component: MessageCircle01 },
  'yzi-chevron-down': { component: ChevronDown },
  'yzi-alert-circle-solid': { component: AlertCircleSolid },
  'yzi-check-circle': { component: CheckCircle },
  'yzi-check-circle-solid': { component: CheckCircleSolid },
  'yzi-copy-03': { component: Copy03 },
  'yzi-plus': { component: Plus },
  'yzi-medical-cross': { component: MedicalCross },
  'yzi-dots-grid-02': { component: DotsGrid02 },
  'yzi-lock-03': { component: Lock03 },
  'yzi-google-icon': { component: GoogleIcon },
  'yzi-search-sm': { component: SearchSm },
  'yzi-filter-funnel-01': { component: FilterFunnel01 },
  'yzi-chevron-up': { component: ChevronUp },
  'yzi-automatic': { component: Automatic },
  'yzi-list': { component: List },
  'yzi-triangle': { component: Triangle },
  'yzi-data-flow-01': { component: DataFlow01 },
  'yzi-star-04': { component: Star04 },
  'yzi-bell-01': { component: Bell01 },
  'yzi-user-01': { component: User01 },
  'yzi-yezza-icon': { component: YezzaIcon },
  'yzi-thumbs-up': { component: ThumbsUp },
  'yzi-star-01': { component: Star01 },
  'yzi-star-01-fill': { component: Star01Fill },
  'yzi-ios-battery-full': { component: IosBatteryFull },
  'yzi-ios-safari-safe-lock': { component: IosSafariSafeLock },
  'yzi-ios-safari-reply-arrow': { component: IosSafariReplyArrow },
  'yzi-gmail-icon': { component: GmailIcon },
  'yzi-check-verified-02': { component: CheckVerified02 },
  'yzi-message-square-02': { component: MessageSquare02 },
  'yzi-chevron-down-double': { component: ChevronDownDouble },
  'yzi-edit-05': { component: Edit05 },
  'yzi-printer': { component: Printer },
  'yzi-layout-left': { component: LayoutLeft },
  'yzi-layout-left-filled': { component: LayoutLeftFilled },
  'yzi-file-04': { component: File04 },
  'yzi-chevron-up-double': { component: ChevronUpDouble },
  'yzi-arrow-narrow-up-right': { component: ArrowNarrowUpRight },
  'yzi-folder': { component: Folder },
  'yzi-colors': { component: Colors },
  'yzi-scan': { component: Scan },
  'yzi-phone': { component: Phone },
  'yzi-corner-down-right': { component: CornerDownRight },
  'yzi-plus-circle': { component: PlusCircle },
  'yzi-x-circle': { component: XCircle },
  'yzi-menu-03': { component: Menu03 },
  'yzi-menu-05': { component: Menu05 },
  'yzi-phone-02': { component: Phone02 },
  'yzi-dotpoints-02': { component: Dotpoints02 },
  'yzi-markerpin-02': { component: Markerpin02 },
  'yzi-mail-02': { component: Mail02 },
  'yzi-123': { component: Number123 },
  'yzi-alarm-clock': { component: AlarmClock },
  'yzi-arrow-up': { component: ArrowUp },
  'yzi-arrow-down': { component: ArrowDown },
  'yzi-key-02': { component: Key02 },
  'yzi-copy-02': { component: Copy02 },
  'yzi-arrow-narrow-left': { component: ArrowNarrowLeft },
  'yzi-circle': { component: Circle },
  'yzi-clock': { component: Clock },
  'yzi-image-01': { component: Image01 },
  'yzi-package-plus': { component: PackagePlus },
  'yzi-download-02': { component: Download02 },
  'yzi-tag-02': { component: Tag02 },
  'yzi-file-06': { component: File06 },
  'yzi-alert-circle': { component: AlertCircle },
  'yzi-image-user-x': { component: ImageUserX },
  'yzi-box': { component: Box },
  'yzi-ticket-01': { component: Ticket01 },
  'yzi-cube-01': { component: Cube01 },
  'yzi-monitor-05': { component: Monitor05 },
  'yzi-file-heart-02': { component: FileHeart02 },
  'yzi-home-smile': { component: HomeSmile },
  'yzi-lock-keyhole-circle': { component: LockKeyholeCircle },
  'yzi-palette': { component: Palette },
  'yzi-slash-circle-01': { component: SlashCircle01 },
  'yzi-stars-02': { component: Stars02 },
  'yzi-log-out-01': { component: LogOut01 },
  'yzi-medical-square': { component: MedicalSquare },
  'yzi-edit-03': { component: Edit03 },
  'yzi-eye': { component: Eye },
  'yzi-calendar-filter': { component: CalendarFilter },
  'yzi-bar-chart-10': { component: BarChart10 },
  'yzi-pencil-line': { component: PencilLine },
  'yzi-file-attachment-01': { component: FileAttachment01 },
  'yzi-file-07': { component: File07 },
  'yzi-file-search-02': { component: FileSearch02 },
  'yzi-dots-horizontal': { component: DotsHorizontal },
  'yzi-columns-03': { component: Columns03 },
  'yzi-layout-top': { component: LayoutTop },
  'yzi-grid-01': { component: Grid01 },
  'yzi-calendar-tick': { component: CalendarTick },
  'yzi-repeat-03': { component: Repeat03 },
  'yzi-repeat-01': { component: Repeat01 },
  'yzi-check': { component: Check },
  'yzi-play-circle': { component: PlayCircle },
  'yzi-pause-circle': { component: PauseCircle },
  'yzi-info-square': { component: InfoSquare },
  'yzi-activity-heart': { component: ActivityHeart },
  'yzi-users-03': { component: Users03 },
  'yzi-save-01': { component: Save01 },
  'yzi-hourglass-02': { component: Hourglass02 },
  'yzi-info-circle': { component: InfoCircle },
  'yzi-file-05': { component: File05 },
  'yzi-arrow-up-right': { component: ArrowUpRight },
  'yzi-users-solid-03': { component: UsersSolid03 },
  'yzi-calendar-solid': { component: CalendarSolid },
  'yzi-clock-check-solid': { component: ClockCheckSolid },
  'yzi-package-check-solid': { component: PackageCheckSolid },
  'yzi-calendar-check-solid-01': { component: CalendarCheckSolid01 },
  'yzi-marker-pin-solid-04': { component: MarkerPinSolid04 },
  'yzi-archive': { component: Archive },
  'yzi-link-03': { component: Link03 },
  'yzi-text-input': { component: TextInput },
  'yzi-users-plus': { component: UsersPlus },
  'yzi-wallet-solid-02': { component: WalletSolid02 },
  'yzi-alert-square': { component: AlertSquare },
  'yzi-user-plus-solid-01': { component: UserPlusSolid01 },
  'yzi-coins-hand-solid': { component: CoinsHandSolid },
  'yzi-gift-solid-01': { component: GiftSolid01 },
  'yzi-alert-triangle': { component: AlertTriangle },
  'yzi-check-verified-solid-03': { component: CheckVerifiedSolid03 },
  'yzi-gift-02': { component: Gift02 },
  'yzi-phone-02-new': { component: Phone02New },
  'yzi-message-dots-square': { component: MessageDotsSquare },
  'yzi-link-01': { component: Link01 },
  'yzi-presentation-chart-01': { component: PresentationChart01 },
  'yzi-refresh-cw-02': { component: RefreshCw02 },
  'yzi-share-03': { component: Share03 },
  'yzi-home-03': { component: Home03 },
  'yzi-delete': { component: Delete },
  'yzi-award-02': { component: Award02 },
  'yzi-message-text-square-02': { component: MessageTextSquare02 },
  'yzi-zap': { component: Zap },
  'yzi-offers': { component: Offers },
  'yzi-attachment-01': { component: Attachment01 },
  'yzi-maximize-01': { component: Maximize01 },
  'yzi-file-02': { component: File02 },
  'yzi-clipboard': { component: Clipboard },
  'yzi-clipboard-check': { component: ClipboardCheck },
  'yzi-package': { component: Package },
  'yzi-stethoscope': { component: Stethoscope },
  'yzi-medicine': { component: Medicine },
  'yzi-calculator': { component: Calculator },
  'yzi-check-square-solid': { component: CheckSquareSolid },
  'yzi-checkbox-uncheck': { component: CheckboxUncheck },
  'yzi-check-square': { component: CheckSquare },
  'yzi-layout-alt-duotone-04': { component: LayoutAltDuotone04 },
  'yzi-rows-01': { component: Rows01 },
  'yzi-bar-chart-square-line-01': { component: BarChartSquareLine01 },
  'yzi-menu-duocolor-01': { component: MenuDuocolor01 },
  'yzi-bar-chart-solid-04': { component: BarChartSolid04 },
  'yzi-shopping-cart-line-03': { component: ShoppingCartLine03 },
  'yzi-calculator-line': { component: CalculatorLine },
  'yzi-truck-line-02': { component: TruckLine02 },
  'yzi-bell-ringing-line-02': { component: BellRingingLine02 },
  'yzi-calendar-check-line-01': { component: CalendarCheckLine01 },
  'yzi-bar-chart-square-solid-01': { component: BarChartSquareSolid01 },
  'yzi-package-solid': { component: PackageSolid },
  'yzi-bell-solid-01': { component: BellSolid01 },
  'yzi-dispense': { component: Dispense },
  'yzi-line-send-01': { component: LineSend01 },
  'yzi-link-external-solid-01': { component: LinkExternalSolid01 },
  'yzi-qr-code-01': { component: QrCode01 },
  'yzi-file-question-02': { component: FileQuestion02 },
  'yzi-switch-horizontal-duotone-01': { component: SwitchHorizontalDuotone01 },
  'yzi-edit-01': { component: Edit01 },
  'yzi-repeat-04': { component: Repeat04 },
  'yzi-x-sm': { component: XSm },
  'yzi-reverse-left': { component: ReverseLeft },
  'yzi-marker-pin-01': { component: MarkerPin01 },
  'yzi-building-01': { component: Building01 },
  'yzi-settings-01': { component: Settings01 },
  'yzi-cursor-click-line-01': { component: CursorClickLine01 },
  'yzi-link-broken-02': { component: LinkBroken02 },
  'yzi-calendar-plus-02': { component: CalendarPlus02 }
}
